













































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import barListDataJson from './json/barListData.json'
import preColors from './json/pre_colors.json'
import temColors from './json/tem_colors.json'
import windElement from '@/utils/windElement'
import staIdsData from '@/utils/staIdsData.json'
import CimissDataService from '@/service/CimissDataService'
import statistics from './statistics.vue'
import filterCondition from './filter_condition.vue'
import statisticsList from "@/assets/json/statisticsList.json";
import colorGroupAll from './color_group_all.vue'
import { redefineStationInfo } from '@/utils/stations_utils'
import { Notify } from 'vant'

export default Vue.extend({

  props: [
    'mapData', 'mapUnit'
  ],
  components: {
    statistics, filterCondition, colorGroupAll
  },
  data() {
    return {
      barListData: barListDataJson,
      barId: '',
      subListData: [] as any,
      subId: '',
      startTime: '',
      endTime: '',
      timeTag: 0,
      timeShow: false,
      minDate: new Date(2019, 0, 1, 0),
      maxDate: new Date(),
      currentDate: new Date(),
      initData: [],
      timeRange: '',
      timeStr: '',
      hourNum: 0,
    }
  },
  created() {
    this.barId = this.$route.params.id
    if (this.barId !== 'radar' && this.barId !== 'satellite' && this.barId !== 'radar_mosaic') {

      this.barListData = this.barListData.slice(0, 5)
    } else {
      this.barListData = this.barListData.slice(5, this.barListData.length)
    }
    this.barListData.filter((e: any) => {
      if (e.id === this.barId) {
        if (e.children) {
          this.subListData = e.children
        } else {
          this.subListData = []
        }
      }
    })
    if (this.subListData.length > 0) {
      this.subId = this.subListData[0].id
    } else {
      this.subId = this.barId
    }
    if (this.barId !== 'pre' || this.subId == 'pre_1h') {
      this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
      this.getliveData()
    } else {
      this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
      const start = moment(new Date()).add(-1, 'hour').format('YYYYMMDDHH0000')
      const end = moment(new Date()).format('YYYYMMDDHHmm00')
      this.timeRange = `${start},${end}`
      this.getStatData()
    }
  },
  methods: {
    checkCondition(value: any) {
      this.$emit('checkCondition', value)

    },
    changeBar(id: any) {

      if ('satellite' === id) {
        Notify('风云四号A星停止地面接收与实时数据服务,请等待修复')
        return
      }


      this.hourNum = 0
      this.barId = id

      if (id !== 'radar' && id !== 'satellite') {
        this.barListData.filter((e: any) => {
          if (e.id === this.barId) {
            if (e.children) {
              this.subListData = e.children
            } else {
              this.subListData = []
            }
          }
        })
        if (this.subListData.length > 0) {
          this.subId = this.subListData[0].id
        } else {
          this.subId = this.barId
        }
        this.$emit('changeBar', id)
        this.$emit('changeSub', this.subId)
        if (this.barId !== 'pre') {
          this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
          this.getliveData()
        } else {
          this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
          const start = moment(new Date()).format('YYYYMMDDHH0000')
          const end = moment(new Date()).format('YYYYMMDDHH0000')
          this.timeRange = `${start},${end}`
          this.getStatData()
        }
      } else {
        this.$emit('changeBar', id)
        const params = {
          data: [],
          timeStr: '',
        }
        this.$emit('getData', params)
      }
    },
    changeSub(id: any) {

      this.subId = id
      //任意时间降水
      if (id === 'pre_any') {
        this.startTime = moment(this.currentDate).add(-1, 'hours').format('YYYY-MM-DD HH:00')
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
        this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
      }
      //降水统计
      if (this.barId === 'pre') {
        this.hourNum = 0
        this.timeStr = ''
        let num = ''
        let start = ''
        let end = ''
        const nowHour = moment(new Date()).format('HH')

        let startMoment
        let endMoment


        if (id === 'pre_0808') {

          if (Number(nowHour) >= 8) {
            startMoment = moment(new Date()).set({ hour: 8 }).add(-24, 'hours')
            endMoment = moment(new Date()).set({ hour: 8 })

          } else {

            startMoment = moment(new Date()).set({ hour: 8 }).add(-24 * 2, 'hours')
            endMoment = moment(new Date()).set({ hour: 8 }).add(-24, 'hours')
          }
        } else if (id === 'pre_2020') {
          if (Number(nowHour) >= 20) {
            startMoment = moment(new Date()).set({ hour: 20 }).add(-24, 'hours')
            endMoment = moment(new Date()).set({ hour: 20 })
          } else {
            startMoment = moment(new Date()).set({ hour: 20 }).add(-24 * 2, 'hours')
            endMoment = moment(new Date()).set({ hour: 20 }).add(-24, 'hours')
          }
        } else {
          num = this.subId.split('_')[1].split('h')[0]
          startMoment = moment(new Date()).add(- (Number(num)), 'hours')
          endMoment = moment(new Date())
        }
        start = startMoment.format('YYYYMMDDHH0000')
        end = endMoment.format('YYYYMMDDHH0000')
        this.timeRange = `${start},${end}`
        if (num === '1') {
          this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
        } else {
          this.timeStr = `${startMoment.format('YYYY年MM月DD日HH时00分')}-${endMoment.format('MM月DD日HH时00分')}`
        }
        this.getStatData()
      }
      //最高/最低温度 
      else if (this.barId === 'tem' && this.subId !== 'tem') {
        const start = moment(new Date()).add(-24, 'hours').format('YYYYMMDDHH0000')
        const end = moment(new Date()).format('YYYYMMDDHH0000')
        this.timeRange = `${start},${end}`
        this.timeStr = `${moment(new Date()).add(-24, 'hours').format('YYYY年MM月DD日HH时00分')}-${moment(new Date()).format('MM月DD日HH时00分')}`
        this.getStatData()
      }
      //实时温度 
      else if ((this.barId === 'tem' && this.subId === 'tem') || (this.barId === 'wind' && this.subId != 'win_s_inst_max_24h')) {
        this.hourNum = 0
        this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
        this.getliveData()
      } else if (this.barId === 'wind' && this.subId === 'win_s_inst_max_24h') {
        const start = moment(new Date()).add(-24, 'hours').format('YYYYMMDDHH0000')
        const end = moment(new Date()).format('YYYYMMDDHH0000')
        this.timeRange = `${start},${end}`
        this.timeStr = `${moment(new Date()).add(- (Number(24)), 'hours').format('YYYY年MM月DD日HH时')}-${moment(new Date()).format('MM月DD日HH时')}`
        this.getStatData()
      } else {
        this.getTableData()
      }
      this.$emit('changeSub', id)
    },
    // 任意时间查询
    changeTime(value: any) {
      this.timeTag = value
      this.timeShow = true
      if (this.timeTag === 1) {
        const arr = this.startTime.split(':')[0].split(' ')[0].split('-')
        arr.push(this.startTime.split(':')[0].split(' ')[1])
        this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
      } else {
        const arr = this.endTime.split(':')[0].split(' ')[0].split('-')
        arr.push(this.endTime.split(':')[0].split(' ')[1])
        this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
      }
    },
    confirm() {
      this.timeShow = false
      if (this.timeTag === 1) {
        this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
      } else {
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
      }
    },
    cancel() {
      this.timeShow = false
    },
    query() {
      const arrStart = this.startTime.split(' ')
      const arrEnd = this.endTime.split(' ')
      const start = arrStart[0].replace(/-/g, '') + arrStart[1].split(':')[0] + '0000'
      const utfStart = moment(start, 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss')
      const end = arrEnd[0].replace(/-/g, '') + arrEnd[1].split(':')[0] + '0000'
      const utfEnd = moment(end, 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss')
      this.timeRange = `${utfStart},${utfEnd}`
      this.timeStr = `${moment(start, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}-${moment(end, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}`
      console.log(this.timeStr)
      this.getStatData()
    },
    getliveData() {
      const elements = 'station_name,pre_1h,station_id_c,tem,tem_min,tem_max,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_s_inst_max_otime,win_d_inst_max,rhu,lat,lon,datetime,prs'
      CimissDataService.stationData('', config.defaultStationObj.adminCode, '', '', elements).then((data: any) => {
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData
        this.getTableData()
      })
    },
    getStatData() {
      const getTimeRange = this.timeRange.split(',')
      const startTime = moment(getTimeRange[0], 'YYYYMMDDHH0000').subtract(8,'hours').format('YYYYMMDDHHmmss')
      const endTime = moment(getTimeRange[1], 'YYYYMMDDHH0000').subtract(8,'hours').format('YYYYMMDDHHmmss')
      console.log(startTime)
      this.timeRange=`${startTime},${endTime}`

      const elements = 'station_name,station_id_c,pre_1h,tem_min,tem_max,win_s_inst_max,lat,lon'
      CimissDataService.stationStatData('', config.defaultStationObj.adminCode, this.timeRange, '', elements).then((data: any) => {
        // request.get(url, params).then((data) => {
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData
        this.getTableData()
      })
    },
    changeHour(value: any) {
      // console.log(value)
      let num = this.hourNum
      if (value === 'back' && this.hourNum > -24) {
        if (this.hourNum <= 0 && this.hourNum > -24) {
          num--
        }
        this.hourNum = num
      } else if (value === 'next' && this.hourNum < 0) {
        if (this.hourNum < 0 && this.hourNum >= -24) {
          num++
        }
        this.hourNum = num
      }
      this.timeStr = moment().add(this.hourNum, 'hour').format('YYYY年MM月DD日HH时')
      this.gethistData()
    },
    gethistData() {
      const times = `${moment().add(this.hourNum, 'hours').add(-8, 'hours').format('YYYYMMDDHH0000')}`
      const elements = 'station_name,station_id_c,pre_1h,tem,tem_min,tem_max,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_s_inst_max_otime,win_d_inst_max,rhu,lat,lon,datetime,prs'
      CimissDataService.stationData('', config.defaultStationObj.adminCode, '', times, elements).then((data: any) => {
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData

        this.getTableData()
      })
    },
    getTableData() {
      let key = this.subId
      if (this.barId === 'pre') {
        key = 'pre_1h'
      }
      if (this.subId === 'win_s_inst_max_24h') {
        key = 'win_s_inst_max'
      }
      const data = JSON.parse(JSON.stringify(this.initData))

      let arrBgColor = [] as any
      if (this.barId === 'pre') {
        let name = this.subId
        if (name === 'pre_0808' || name === 'pre_2020') {
          name = 'pre_any'
        }
        // @ts-ignore
        const detailStatJson = statisticsList[name].data
        arrBgColor = detailStatJson
      } else if (this.barId === 'tem') {
        const detailStatJson = statisticsList[this.barId].data
        arrBgColor = detailStatJson
      }
      data.map((e: any) => {
        e.value = e[key]
        if (this.barId === 'wind') {
          e.bgColor = ''
          e.level = windElement.windLevel(e[key])

          e.windImg = windElement.windVane(e.value)
          if (key === 'win_s_avg_2mi') {
            e.rotate = e.win_d_avg_2mi
          } else if (key === 'win_s_inst_max') {
            e.rotate = e.win_d_inst_max

          }
        } else if (this.barId === 'rhu') {
          e.bgColor = '#00BFFF'
        } else if (this.barId === 'prs') {
          e.bgColor = '#00BFFF'
        }
        arrBgColor.map((k: any) => {
          const value = k.value
          const rgbcolor = k.rgbcolor
          if (e.value >= value[0] && e.value < value[1]) {
            e.bgColor = `rgba(${rgbcolor[0]}, ${rgbcolor[1]}, ${rgbcolor[2]}, 1.0)`

          }
          if (this.barId === 'pre') {
            if (e.value < 0.09) {
              e.bgColor = 'rgba(0, 0, 0, 0.20)'
            }
          }
        })
      })

      let arr = data
      if (this.barId != 'tem') {
        arr = data.filter((e: any) => {
          return e.value >= 0
        })
      }
      const params = {
        // data,
        data: arr,
        timeStr: this.timeStr,
      }

      this.$emit('getData', params)
    },
  },
})
